import { FlotionMark, FlotionWordmark } from "@/components/brand/FlotionLogo";
import { ThemeToggle } from "./ThemeToggle";

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen">
      {/* Left brand panel — dark cartographic with yellow-tinted graticule */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-sidebar">
        {/* Decorative graticule pattern */}
        <div className="absolute inset-0 opacity-[0.12]">
          <svg aria-hidden="true" className="h-full w-full" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="auth-grid" width="40" height="40" patternUnits="userSpaceOnUse">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#f5c344" strokeWidth="1" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#auth-grid)" />
          </svg>
        </div>
        <div className="relative z-10 flex flex-col justify-center px-12 xl:px-16">
          <div className="flex items-center gap-3">
            <FlotionMark size={44} />
            <FlotionWordmark height={40} className="text-sidebar-foreground" />
          </div>
          <p className="mt-5 text-lg text-sidebar-foreground/70 max-w-md leading-relaxed">
            Location intelligence for commercial real estate. Know your next move.
          </p>
        </div>
      </div>

      {/* Right form panel */}
      <div className="flex w-full lg:w-1/2 flex-col bg-background">
        {/* Mobile brand header */}
        <div className="flex items-center justify-between p-4 lg:justify-end">
          <span className="flex items-center gap-2 lg:hidden">
            <FlotionMark size={24} />
            <FlotionWordmark height={20} className="text-foreground" />
          </span>
          <ThemeToggle />
        </div>

        {/* Centered form */}
        <div className="flex flex-1 items-center justify-center px-4 pb-12">
          <div className="w-full max-w-md">{children}</div>
        </div>
      </div>
    </div>
  );
}
